export const environment = {
  apiUrl: 'https://siteprofiler.develop.codeable.io',
  wsUrl: 'siteprofiler.develop.codeable.io',
  pusher: {
    key: '3f1ba9887bfab0ab61c8',
    cluster: "mt1"
  },
  production: false
};
